import apicall from "../shared/utils/apicall";
export function addTodo(detail) {
  if (typeof detail === "function") detail = detail();
  return apicall.post("/todo", {
    detail: detail
  });
}
export function getTodoList() {
  return apicall.get("/todo");
}
export function updateTodo(id, detail) {
  return apicall.patch("/todo", {
    id: id,
    detail: detail
  });
}
export function deleteTodo(id) {
  return apicall.callDelete("/todo/".concat(id));
}